import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Carlos R.',
  age: '48 años',
  text: 'De sentirme agotado a las 3 PM a tener claridad mental total hasta la noche. Mi mejor inversión este año.',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=150&q=80'
}, {
  name: 'Marco T.',
  age: '42 años',
  text: 'Los resultados en mi libido fueron evidentes en menos de 10 días. Increíble.',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&q=80'
}, {
  name: 'Javier L.',
  age: '54 años',
  text: 'Simplemente funciona. Recuperé la agresividad competitiva que creía perdida.',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=150&q=80'
}];
export function Testimonials() {
  return <section className="py-20 px-4 bg-brand-darker border-y border-brand-gray" data-id="element-172">
      <div className="max-w-6xl mx-auto" data-id="element-173">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-174">
          <h2 className="text-3xl md:text-5xl font-bold text-white uppercase mb-4" data-id="element-175">
            Hombres que ya recuperaron su{' '}
            <span className="text-brand-orange" data-id="element-176">chispa</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-177">
          {testimonials.map((t, idx) => <motion.div key={idx} className="bg-brand-dark p-8 rounded-xl border border-brand-gray relative" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} data-id="element-178">
              <div className="flex items-center gap-1 mb-4" data-id="element-179">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-orange text-brand-orange" data-id="element-180" />)}
              </div>
              <p className="text-brand-text text-lg italic mb-6" data-id="element-181">"{t.text}"</p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-182">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-brand-orange/50 grayscale" data-id="element-183" />
                <div data-id="element-184">
                  <h4 className="text-white font-bold uppercase" data-id="element-185">{t.name}</h4>
                  <span className="text-brand-muted text-sm" data-id="element-186">{t.age}</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}